module.exports = __webpack_public_path__ + "static/fonts/Simple-Line-Icons.d228596.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/simple-line-icons/fonts/Simple-Line-Icons.ttf
// module id = 2233
// module chunks = 1